/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_SavedInputs */

const en_settings_profile_saved = /** @type {(inputs: Settings_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings saved`)
};

/**
* | output |
* | --- |
* | "Settings saved" |
*
* @param {Settings_Profile_SavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_profile_saved = /** @type {((inputs?: Settings_Profile_SavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_SavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_profile_saved(inputs)
});
export { settings_profile_saved as "settings.profile.saved" }